<template>
  <div id="credit_card2" class="description collapse show">
    <div class="form-container active">
      <form id="card_form" action="" class="card-form">
        <div class="form-group">
          <div class="card-wrapper">
            <div v-show="showExpressCheckout">
              <div id="express-checkout-element">
                <!-- Express Checkout Element will be inserted here -->
              </div>
              <span class="stripe-choice">or</span>
            </div>
            <div id="payment-element-v3">
              <!--Stripe.js injects the Payment Element-->
            </div>

            <div id="payment-message" class="hidden"></div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EventBus from "@/event-bus";

export default {
  name: "StripeElementsMethod",
  props: {
    method: {
      type: Object,
      default: function () {
        return {
          gateway: "stripe",
          client_side_gateway: null,
        };
      },
    },
  },
  data: function () {
    return {
      stripeError: null,
      complete: false,
      showExpressCheckout: false,
    };
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart,
      currency: (state) => state.currency,
    }),
  },
  updateElements() {
    console.log("updateElements");

    window.$stripe.elements.update({
      amount: Math.round(this.cart.total * 100),
      currency: this.currency.toLowerCase(),
    });
  },
  mounted() {
    window.$stripe = {};
    window.$stripe.stripe = window.Stripe(
      this.method.client_side_gateway.pub_api_key,
      {
        stripeAccount: this.method.client_side_gateway.stripe_account,
      }
    );

    // pull in the appearance parameters from the page (if present)
    let appearance = Object.assign(
      { theme: "stripe" },
      window.dpdCartOptions?.stripeElements?.appearance
    );
    // console.log(appearance);

    window.$stripe.elements = window.$stripe.stripe.elements({
      mode: "payment",
      amount: Math.round(this.cart.total * 100),
      currency: this.currency.toLowerCase(),
      // paymentMethodTypes: ["card", "link", "klarna", "demo_pay"],
      // paymentMethodTypes: ["card"],
      paymentMethodCreation: "manual",
      // paymentMethodTypes: ["card"],
      // Fully customizable with appearance API.
      appearance: appearance,
      // clientSecret: this.method.custom.payment_intent.client_secret
    });
    const paymentElementOptions = {
      layout: {
        type: "tabs",
        defaultCollapsed: false,
      },
      wallets: {
        applePay: "never",
        googlePay: "never",
      },
    };
    const paymentElement = window.$stripe.elements.create(
      "payment",
      paymentElementOptions
    );
    paymentElement.mount("#payment-element-v3");
    window.$stripe.card = paymentElement;

    const expressCheckoutOptions = {
      layout: {
        overflow: "never",
      },
      paymentMethodOrder: ["applePay", "googlePay", "link"],
    };
    const expressCheckoutElement = window.$stripe.elements.create(
      "expressCheckout",
      expressCheckoutOptions
    );
    expressCheckoutElement.mount("#express-checkout-element");
    expressCheckoutElement.on("confirm", () => {
      console.log("stripe-express-checkout-confirm");
      EventBus.$emit("stripe-express-checkout-confirm");
    });
    expressCheckoutElement.on("ready", ({ availablePaymentMethods }) => {
      console.log(availablePaymentMethods);
      this.showExpressCheckout = !!availablePaymentMethods;
      // if (!availablePaymentMethods) {
      //   // No buttons will show
      // } else {
      //   // Optional: Animate in the Element
      //   expressCheckoutDiv.style.visibility = "initial";
      // }
    });
    window.$stripe.expressCheckoutElement = expressCheckoutElement;

    // doesn't work and doesn't seem to be needed
    // this.unwatch = this.$store.watch(
    //   (state) => state.cart.total,
    //   this.updateElements
    // );
  },
  destroyed() {
    // this.unwatch();
  },
};
</script>

<style scoped>
.stripe-choice {
  display: block;
  text-align: center;
  margin: 10px 0;
  font-size: 1.2em;
  /* font-weight: bold; */
  color: #666;
}
</style>
